import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';

import ManualAutofinalizationSection from './manualautofinalizationsection';
import EncounterProcessingSection from './encounterprocessingsection';
import AuditSection from './auditsection';
import PrioritizationSection from './prioritizationsection';

const useStyles = makeStyles(theme => ({
  root: {
    borderTop: 'solid 2px black',
    padding: '0.5em',
    marginTop: '12px'
  }
}));

const ManagementSection = ({
  contractSettingsData,
  boundActions,
  priorityWorkByState,
  priorityStrategyState,
  isACA = false
}) => {
  const {
    autofinalizeOptions,
    selectedContract: { contractId, description }
  } = contractSettingsData;

  const classes = useStyles();

  return (
    <div className={classes.root}>
      {/* title */}
      <div>
        <h4>Settings For: {description}</h4>
      </div>

      <div>
        <h4>
          HCC Model Category Version(s):
          {
            contractSettingsData.contractCodeCategoryVersions.length === 0
              ? 'NONE SELECTED FOR CONTRACT'
              : contractSettingsData.contractCodeCategoryVersions
                  .map(x => x.description)
                  .join(', ')
          }
        </h4>
      </div>

      {/* Manual Autofinalization Section */}
      <ManualAutofinalizationSection
        autofinalizeOptions={autofinalizeOptions}
        boundActions={boundActions}
        contractId={contractId}
      />

      {/* EncounterProcessingSection */}
      <EncounterProcessingSection
        contractSettingsData={contractSettingsData}
        boundActions={boundActions}
      />

      {/* AuditSection */}
      <AuditSection
        contractSettingsData={contractSettingsData}
        boundActions={boundActions}
        isACA={isACA}
      />

      {/*Prioritization Section */}
      <PrioritizationSection
        contractId={contractId}
        contractSettingsData={contractSettingsData}
        boundActions={boundActions}
        priorityStrategyState={priorityStrategyState}
        priorityWorkByState={priorityWorkByState}
      />

    </div>
  );
};

ManagementSection.propTypes = {
  contractSettingsData: PropTypes.object.isRequired,
  boundActions: PropTypes.object.isRequired,
  isACA: PropTypes.bool.isRequired
};

export default ManagementSection;
